<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 96.891">
  <path
    d="M14.152 41.764a1.67 1.67 0 0 1-2.309 1.542L4.126 40.11a6.69 6.69 0 0 1-3.617-8.731 6.69 6.69 0 0 1 8.731-3.616 1.67 1.67 0 1 1-1.278 3.087 3.346 3.346 0 0 0-4.367 1.808 3.347 3.347 0 0 0 1.809 4.365l7.717 3.197a1.668 1.668 0 0 1 1.031 1.544Z"
    fill="#754f1e"
  />
  <path
    d="M14.152 55.127a1.67 1.67 0 0 1-1.031 1.544l-7.717 3.196a3.348 3.348 0 0 0-1.809 4.365 3.347 3.347 0 0 0 4.367 1.809 1.67 1.67 0 1 1 1.278 3.087 6.69 6.69 0 0 1-8.731-3.616 6.69 6.69 0 0 1 3.615-8.731l7.719-3.197a1.67 1.67 0 0 1 2.309 1.543Z"
    fill="#754f1e"
  />
  <circle
    cx="24.175"
    cy="48.446"
    r="15.035"
    fill="#f9c900"
  />
  <circle
    cx="15.822"
    cy="53.458"
    r="1.671"
    fill="#754f1e"
  />
  <circle
    cx="15.822"
    cy="43.435"
    r="1.671"
    fill="#754f1e"
  />
  <path
    d="M34.199 41.763c0 8.304-6.732 15.035-15.035 15.035a14.971 14.971 0 0 1-9.051-3.03c2.15 5.676 7.633 9.712 14.062 9.712 8.304 0 15.035-6.731 15.035-15.034a15.01 15.01 0 0 0-5.984-12.005c.627 1.654.973 3.448.973 5.322Z"
    fill="#f9aa0c"
  />
  <path
    d="M59.257 71.833c-12.917 0-23.388-10.471-23.388-23.388 0-12.916 10.471-23.387 23.388-23.387 11.056 0 33.782 17.134 40.101 22.071a1.67 1.67 0 0 1 0 2.633c-6.319 4.937-29.046 22.071-40.101 22.071Z"
    fill="#836134"
  />
  <path
    d="M65.288 61.81c-12.916 0-23.387-10.471-23.387-23.388 0-2.312.337-4.545.962-6.654a23.315 23.315 0 0 0-6.994 16.678c0 12.916 10.471 23.387 23.388 23.387 11.055 0 33.782-17.134 40.101-22.071a1.67 1.67 0 0 0 0-2.633c-.524-.409-1.163-.904-1.896-1.464-9.586 6.869-24.039 16.145-32.174 16.145Z"
    fill="#754f1e"
  />
  <path
    d="M59.257 25.058c-2.943 0-5.759.545-8.353 1.537v43.7a23.316 23.316 0 0 0 8.353 1.538c.531 0 1.089-.04 1.67-.116V25.174a12.916 12.916 0 0 0-1.67-.116Z"
    fill="#f9ce19"
  />
  <path
    d="M70.951 68.313c3.267-1.567 6.696-3.524 10.023-5.596V34.174c-3.327-2.072-6.756-4.03-10.023-5.596v39.735Z"
    fill="#f9ce19"
  />
  <path
    d="M50.904 70.295a23.316 23.316 0 0 0 8.353 1.538c.531 0 1.089-.04 1.67-.116V61.402a23.281 23.281 0 0 1-10.023-4.538v13.431Z"
    fill="#fab224"
  />
  <path
    d="M70.951 68.313c3.267-1.567 6.696-3.524 10.023-5.596v-6.483c-3.504 1.918-6.946 3.529-10.023 4.518v7.561Z"
    fill="#fab224"
  />
  <path
    d="M35.868 50.116S20.834 23.338 20.834 15.035C20.834 6.731 27.565 0 35.868 0c8.304 0 15.035 6.731 15.035 15.035 0 8.303-15.035 35.081-15.035 35.081Z"
    fill="#f1ede8"
  />
  <path
    d="M35.869 46.775S20.835 73.553 20.835 81.856c0 8.303 6.731 15.035 15.034 15.035 8.304 0 15.035-6.73 15.035-15.035 0-8.303-15.035-35.081-15.035-35.081Z"
    fill="#f1ede8"
  />
  <path
    d="M32.473 53.065c3.883 7.191 13.418 25.52 13.418 32.134a14.99 14.99 0 0 1-4.362 10.588c5.497-2.239 9.374-7.629 9.374-13.93 0-8.303-15.035-35.081-15.035-35.081s-1.424 2.537-3.395 6.289Z"
    fill="#e3dcd2"
  />
  <path
    d="M32.474 43.826c3.883-7.19 13.418-25.52 13.418-32.133 0-4.13-1.666-7.87-4.362-10.587 5.497 2.236 9.374 7.628 9.374 13.928 0 8.304-15.035 35.082-15.035 35.082s-1.424-2.537-3.395-6.29Z"
    fill="#e3dcd2"
  />
</svg>
